import { Controller } from "@hotwired/stimulus"
import Swiper from "swiper"
import { Navigation } from "swiper/modules"
import "swiper/css"
import "swiper/css/navigation"

export default class extends Controller {
  static targets = ["prev", "next", "content"]

  static values = {
    centerMode: Boolean,
    slidesCount: Number,
    maxSlidesToShow: Number,
    minSlidesToShow: Number,
    smSlidesToShow: Number,
    mdSlidesToShow: Number,
    initialSlide: Number,
    next: String,
    prev: String,
    loop: Boolean
  }

  connect() {
    this.initializeSwiper()
  }

  disconnect() {
    if (this.swiper) this.swiper.destroy()
  }

  initializeSwiper() {
    this.swiper = new Swiper(this.element, {
      modules: [Navigation],
      updateOnWindowResize: true,
      centeredSlides: this.centerModeValue,
      watchOverflow: false,
      slidesPerView: "auto",
      spaceBetween: 10,
      initialSlide: this.initialSlideValue || 0,
      breakpoints: {
        300: { slidesPerView: this.minSlidesToShowValue, spaceBetween: 10 },
        576: { slidesPerView: this.smSlidesToShowValue || 2, spaceBetween: 10 },
        768: { slidesPerView: this.mdSlidesToShowValue || 3, spaceBetween: 10 },
        992: { slidesPerView: this.maxSlidesToShowValue, spaceBetween: 10 },
        1200: { slidesPerView: this.maxSlidesToShowValue, spaceBetween: 10 },
        1400: { slidesPerView: this.maxSlidesToShowValue, spaceBetween: 20 }
      },
      loop: this.loopValue || false,
      lazy: true,
      navigation: {
        nextEl: this.nextValue,
        prevEl: this.prevValue
      }
    })

    this.waitForSwiper()
    this.swiper.on("slideChange", () => this.applyCenterZoom())
  }

  waitForSwiper() {
    const check = () => {
      if (this.swiper && this.swiper.slides.length > 0) {
        this.applyCenterZoom()
      } else {
        requestAnimationFrame(check)
      }
    }

    check()
  }

  applyCenterZoom() {
    if (!this.swiper) return

    this.swiper.slides.forEach(slide => {
      slide.style.transform = "scale(0.85)"
      slide.style.transition = "transform 0.3s ease"
      slide.style.zIndex = "10"
    })

    const activeSlide = this.swiper.slides[this.swiper.activeIndex]
    if (activeSlide) {
      activeSlide.style.transform = "scale(1)"
      activeSlide.style.zIndex = "20"
    }
  }
}
